var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('HeaderFixed'),(!_vm.hideSlider)?_c('HeaderSlider',{attrs:{"slideList":_vm.slideList}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }